<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title link="/projects" title="Projects"></header-title>
        <projects-menu :menu-items="types" :base-link="'project-type'" :currentItem="currentType"></projects-menu>
      </div>
    </page-header>
    <div class="body">
      <h1 id="summary" class="">Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.</h1>
      <div v-if="currentType.projects.length" class="projects">
        <project v-for="(project, index) in currentType.projects" :key="index" :project="project"></project>
      </div>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
import Project from './Project'
import ProjectsMenu from './ProjectsMenu'
export default {
  name: 'projects',
  data () {
    return {
      types: DataStore.types
    }
  },
  computed: {
    currentType () {
      return this.types.find((type) => { return type.alias === this.$route.params.alias })
    }
  },
  components: {
    HeaderTitle,
    PageHeader,
    Project,
    ProjectsMenu
  }
}
</script>



// WEBPACK FOOTER //
// Type.vue?24b13138